import { Option } from "../../util/option";
import { RootCpnt } from "../../services/root-components/get-root-components/GetRootComponentsResponse";
import {
  ErrorMessage,
  ErrorSpreadsheetResult,
} from "../../util/spreadsheet-data-utils";

export type RootComponentListPageState = {
  searchResult: {
    rootCpntList: RootCpnt[];
  };
  dataList: DataList;
};
export type SpreadsheetState = {
  rootCpntList: RootComponent[];
  dataList: DataList;
};

export type RootComponent = {
  isEdited: boolean;
  rootCpnt: RootCpnt;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};
export type RootComponentSpreadsheetRow = RootComponent &
  ErrorSpreadsheetResult;

export type DataList = {
  inDefCommonFlagType: Option[];
};

export type PageNewState =
  | RootComponentListPageState
  | ((prevState: RootComponentListPageState) => RootComponentListPageState);
